import { InquiryStatus } from '@/app/proxy/proxies';

/** Backend `Status` enum values on `InquiryViewModel.status`. */
export const INQUIRY_STATUS = {
  Thinking: InquiryStatus._10,
  Read: InquiryStatus._20,
  Unread: InquiryStatus._30,
} as const;

export function isInquiryThinking(status: InquiryStatus | undefined): boolean {
  return status === INQUIRY_STATUS.Thinking;
}

export function isInquiryUnread(status: InquiryStatus | undefined): boolean {
  return status === INQUIRY_STATUS.Unread;
}

export function isInquiryRead(status: InquiryStatus | undefined): boolean {
  return status === INQUIRY_STATUS.Read;
}
